/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />
/// <reference path="./listMover.controller.ts" />

module Meevo.Components.Controls {
    'use strict';

    export class ListMover implements angular.IDirective {
        restrict = 'E';
        transclude: { [slot: string]: string };
        templateUrl = 'app/components/controls/listMover/listMover.template.html';
        scope = {
            securityAccess: '=?',
            centralOffice: '=?',
            disabled: '=?ngDisabled',
            template: '@',
            allSelectedTemplate: '@?',
            allSelectedSecurityKey: '@?',
            criteria: '=?',
            fetchOnStart: '=?',
            watchCriteria: '=?',
            useAllItemsAsSelected: '=?',
            fullResponse: '=?',
            generic: '=?',
            genericUrl: '=?',
            genericArrayList: '=?',
            identifier: '@?',
            displayName: '@?',
            postLoad: '&?',
            defaultValue: '=?',
            allSelected: '=?',
            isSelectAllCheckboxHidden: '=?',
            hideTopOnCollapse: '=?',
            hideTitles: '=?',
            advancedSearch: '=?',
            required: "=?ngRequired",
            nullIfEmpty: '=?', // set null value in to the model if nothing selected
            setIdOnCriteriaChanged: '=?', // set the array of ids in to the model if the criteria changed and even if all values selected
            useSelectCaptions: '@?',
            reportShortCut: '@?',
            isSystemUserSelected: '=?',
            allSelectedToggleCallback: '=?',
            rightSelectorLabel: '@?',
            leftSelectorLabel: '@?',
            isAdding:'=?',
        };
        bindToController = true;
        controller = Meevo.Components.Controls.ListMoverController;
        controllerAs = '$ctrl';
        require = [
            'meevoListMover', // self controller
            'ngModel'
        ];

        constructor() {
            this.transclude = {
                'top': '?top',
                'controls': '?controls'
            };
        }

        link = (scope: any, element: JQuery, attr: angular.IAttributes, [self, ngModel]) => {
            // use $render in order to make sure we have updated ngModel value in our controller
            ngModel.$render = () => {
                self.ngModel = ngModel;
                self.init();
            };
        };

        static factory(): angular.IDirectiveFactory {
            return () => {
                return new ListMover();
            };
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoListMover', ListMover.factory());
}
